/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */
import './style.scss';

import { Fieldset } from 'primereact/fieldset';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';
import { getAllResearchKpiGroups, getAllResearchKpis } from 'apis/projectProposals.api';
import { useQuery, useMutation } from 'react-query';
import {
  convertUnicodeToAscii,
  formatFileName,
  getExpenditureForExpenditureTableOfSummaryReport,
  modifyBindingSummaryReportProduct,
  setExpenditureTableOfSummaryReport,
} from 'utils/func';

import {
  getSummaryReportProductType,
  getSummaryReportProductGroup,
  updateSummaryReport,
  getSummaryReportType,
  getSummaryReportExpenditureType,
  updateProductFile,
  submitSummaryReport,
  downloadFileReport,
  updateExpenditureFile,
  getSummaryReport,
  deleteProductFile,
  getSummaryReportReviseById,
  createAllocatedExpenditure,
  updateAllocatedExpenditure,
  deleteAllocatedExpenditure,
} from 'apis/summaryReport';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'layout';
import { SUMMARY_REPORT_TYPE, TOAST } from 'constant';

import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { getProjectById, getProjectCode } from 'apis/project.api';
import CustomFileInput from 'components/FormControl/CustomFileInput';
import Loading from 'components/Loading';
import {
  getSummaryReportGroup,
  getSummaryReportProductSpecificType,
  handleResearchResult,
  modifyAllocatedExpenditure,
} from 'utils/func/summaryReport';
import { ASYNC_CONSTANT } from 'constant/summary-report.constant';
import { eachLimit } from 'neo-async';
import GeneralInfo from '../../ReportFormR05/GeneralInfo';
import ExpenditureTable from '../../ReportFormR05/ExpenditureTable';
import Review from '../../ReportFormR05/Review';
import Product from '../../Product';
import ContentCompletedTable from '../../ReportFormR05/ContentCompletedTable';
import ContentNotCompletedTable from '../../ReportFormR05/ContentNotCompletedTable';
import ReviewForm from '../../ReviewForm';
import WorkshopTable from '../../ReportFormR05/WorkshopTable';
import ParticipantsTable from '../../ReportFormR05/ParticipantsTable';
import UploadMultipleFile from '../../ReportFormR05/UploadMultipleFile';
import CompleteReviseModal from './components';
import ManagementAppendix from '../../ReportFormR05/ManagementAppendix';
import RegisteredKPI from '../../Product/RegisteredKPI';

export default function SummaryReportEditForm({
  smrType,
  handleSubmit,
  control,
  reset,
  setValue,
  getValues,
  watch,
  errors,
  tab,
  setTab,
  isDirty,
  dirtyFields,
  checkValidation,
}) {
  const location = useLocation();
  const { id } = location.state || {};

  const { t } = useTranslation();
  const { projectId, summaryReportId } = useParams();

  const navigate = useNavigate();

  const [isWillNext, setIsWillNext] = useState(false);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [isCompleteReviseModalOpen, setIsCompleteReviseModalOpen] = useState(false);
  const [summaryReportAppendixeArray, setSummaryReportAppendixeArray] = useState([]);
  const [appendixFilesDelete, setAppendixFilesDelete] = useState([]);
  const [productFilesDelete, setProductFilesDelete] = useState([]);
  const [transferredTechnologyFilesDelete, setTransferredTechnologyFilesDelete] = useState([]);
  const [resetAppendixFiles, setResetAppendixFiles] = useState(false);
  const [appliedYear, setAppliedYear] = useState(null);

  const [expenditurePeriodsDelete, setExpenditurePeriodsDelete] = useState([]);

  const expenditureFromOtherFund = watch('summaryReportAllocatedExpenditureFromOtherFund') ?? {};

  const { mutateAsync: mutateAsyncUpdateSummary, isLoading: isUpdateSummaryLoading } =
    useMutation(updateSummaryReport);
  const {
    mutateAsync: mutateAsyncUpdateExpenditureFile,
    isLoading: isUpdateExpenditureFileLoading,
  } = useMutation(updateExpenditureFile);
  const { mutateAsync: mutateAsyncUpdateProductFile, isLoading: isUpdateProductFileLoading } =
    useMutation(updateProductFile);
  const { mutateAsync: mutateAsyncSubmitSummaryReport, isLoading: isSubmitSummaryReportLoading } =
    useMutation(submitSummaryReport);
  const { mutateAsync: mutateAsyncDownloadFile, isLoading: isDownloadFileLoading } =
    useMutation(downloadFileReport);

  const { mutateAsync: mutateAsyncDeleteFileAppendix, isLoading: isDeleteFileAppendix } =
    useMutation(deleteProductFile);

  const {
    mutateAsync: mutateAsyncCreateAllocatedExpenditure,
    isLoading: isCreateAllocatedExpenditureLoading,
  } = useMutation(createAllocatedExpenditure);
  const {
    mutateAsync: mutateAsyncUpdateAllocatedExpenditure,
    isLoading: isUpdateAllocatedExpenditureLoading,
  } = useMutation(updateAllocatedExpenditure);
  const {
    mutateAsync: mutateAsyncDeleteAllocatedExpenditure,
    isLoading: isDeleteAllocatedExpenditureLoading,
  } = useMutation(deleteAllocatedExpenditure);
  // # Region data

  const { data: summaryReportTypesData } = useQuery(['summaryReportType'], getSummaryReportType);

  const summaryReportTypeId = useMemo(
    () => summaryReportTypesData?.data?.find((item) => item.code === smrType)?.id,
    [summaryReportTypesData]
  );

  const { data: _projectCode } = useQuery({
    queryKey: () => ['projectCode'],
    queryFn: () => getProjectCode(projectId),
  });

  const projectCode = useMemo(() => _projectCode?.data?.projectCode ?? '', [_projectCode]);

  const { data: _projectData } = useQuery(['project', projectId], () => getProjectById(projectId));

  const [projectData, appliedYearOfResearchKpis] = useMemo(
    () => [
      _projectData?.data ?? [],
      _projectData?.data
        ? _projectData?.data?.projectProposal?.projectProposalResearchKpis?.[0]?.researchKpi
          ?.researchKpiGroup?.appliedYear || 2025
        : 2025,
    ],
    [_projectData]
  );

  const { data: summaryReportExpenditureTypeData } = useQuery(
    ['summaryReportExpenditureType'],
    getSummaryReportExpenditureType
  );

  const summaryReportExpenditureType = useMemo(
    () => summaryReportExpenditureTypeData?.data ?? null,
    [summaryReportExpenditureTypeData]
  );

  const { data: _data } = useQuery(
    ['researchKpis', appliedYear],
    ({ queryKey: [, _appliedYear] }) => getAllResearchKpis({ appliedYear: _appliedYear }),
    {
      enabled: appliedYear !== null,
    }
  );
  const researchKpis = useMemo(() => _data?.data ?? [], [_data]);
  const { data: researchKpiGroupsData } = useQuery(
    ['researchKpiGroups', appliedYear],
    ({ queryKey: [, _appliedYear] }) => getAllResearchKpiGroups({ appliedYear: _appliedYear }),
    { enabled: appliedYear !== null }
  );

  const researchKpiGroups = useMemo(
    () => researchKpiGroupsData?.data ?? [],
    [researchKpiGroupsData]
  );
  const { data: _summaryReportProductType } = useQuery({
    queryKey: ['summaryReportProductType'],
    queryFn: getSummaryReportProductType,
  });

  const summaryReportProductType = useMemo(
    () => _summaryReportProductType?.data ?? [],
    [_summaryReportProductType]
  );

  const { data: _summaryReportProductGroup } = useQuery({
    queryKey: ['summaryReportProductGroup'],
    queryFn: getSummaryReportProductGroup,
  });

  const summaryReportProductGroup = useMemo(
    () => _summaryReportProductGroup?.data ?? [],
    [_summaryReportProductGroup]
  );

  const {
    data: _summaryReport,
    refetch,
    isLoading,
  } = useQuery(['midtermSummaryReport', summaryReportId], () => getSummaryReport(summaryReportId), {
    enabled: summaryReportId !== null,
  });

  const summaryReport = useMemo(() => _summaryReport?.data, [_summaryReport]);

  const { data: summaryReportRevises, refetch: refetchSummaryReportRevises } = useQuery(
    ['summaryReportRevises', summaryReportId],
    () => getSummaryReportReviseById(summaryReportId)
  );

  const isSubmitDocument = useMemo(
    () => summaryReport?.summaryReport?.submittedAt,
    [summaryReport]
  );

  const isEditable = useMemo(
    () =>
      !isSubmitDocument || (!!id && summaryReportRevises?.data?.data.some((item) => item.isRevise)),
    [summaryReportRevises, isSubmitDocument]
  );

  const hasSummaryReportRevise = useMemo(
    () => summaryReportRevises?.data?.data.some((item) => item.isRevise),
    [summaryReportRevises]
  );

  // # End region data

  // # Region Event
  const handleTabChange = () => {
    if (tab === 4) {
      return;
    }
    if (tab < 4 && isWillNext) {
      setTab((prev) => prev + 1);
    }
  };

  const validateRegisteredProductCount = (data) => {
    const shouldValidateProductCount = [
      SUMMARY_REPORT_TYPE.MIDTERM_DOCUMENT,
      SUMMARY_REPORT_TYPE.ACCEPTANCE_DOCUMENT,
    ].includes(smrType);

    if (!shouldValidateProductCount || tab !== 1) {
      return true;
    }

    const registeredSoftProductCount = projectData?.projectProposal?.softProducts?.length ?? 0;
    const registeredHardProductCount = projectData?.projectProposal?.hardProducts?.length ?? 0;
    const actualSoftProductCount = data?.researchResult?.softProducts?.length ?? 0;
    const actualHardProductCount = data?.researchResult?.hardProducts?.length ?? 0;

    if (actualSoftProductCount < registeredSoftProductCount) {
      toast(
        TOAST.ERROR,
        'Số lượng sản phẩm mềm tại B2 phải lớn hơn hoặc bằng số lượng sản phẩm mềm đã đăng ký tại B0.'
      );
      return false;
    }

    if (actualHardProductCount < registeredHardProductCount) {
      toast(
        TOAST.ERROR,
        'Số lượng sản phẩm cứng tại B2 phải lớn hơn hoặc bằng số lượng sản phẩm cứng đã đăng ký tại B0.'
      );
      return false;
    }

    return true;
  };

  const onSubmit = async (data) => {
    if (!validateRegisteredProductCount(data)) {
      return;
    }

    if ((isDirty && Object.keys(dirtyFields).length) || appendixFilesDelete.length > 0) {
      const dataWithExpenditure = getExpenditureForExpenditureTableOfSummaryReport(
        summaryReportExpenditureType,
        data
      );

      const {
        summaryReportAllocatedExpenditures,
        summaryReportAllocatedExpenditureFromOtherFund,
        ...newData
      } = dataWithExpenditure;

      const createOrUpdateSummaryDataSender = modifyBindingSummaryReportProduct(newData);
      createOrUpdateSummaryDataSender.projectId = projectId;
      createOrUpdateSummaryDataSender.summaryReportTypeId = summaryReportTypeId;

      const expenditureFileFormData = new FormData();

      if (data?.expenditureFile instanceof File) {
        const fileName = `${convertUnicodeToAscii(projectCode).replace(
          /\//g,
          '-'
        )}-MinhChungKinhPhi-${summaryReport?.summaryReport?.version || 1}.${
          data?.expenditureFile?.type === 'application/pdf' ? 'pdf' : 'xlsx'
        }`;

        const renamedFile = new File([data?.expenditureFile], fileName, {
          type: data?.expenditureFile?.type,
        });
        expenditureFileFormData.append('expenditureFile', renamedFile);
      }

      const [softProductType, hardProductType, scientificPublicationType] =
        getSummaryReportProductSpecificType(summaryReportProductType);

      const [scientificPublicationGroup, trainingResultGorup, intellectualPropertyGroup] =
        getSummaryReportGroup(summaryReportProductGroup);

      // handle expenditures period
      const mutateExpenditures = modifyAllocatedExpenditure(
        summaryReportAllocatedExpenditures,
        summaryReportAllocatedExpenditureFromOtherFund,
        expenditurePeriodsDelete
      );

      const mutateProducts = [];
      let productFileFormData = new FormData();
      productFileFormData.append('summaryReportId', summaryReportId);
      let count = 0;
      if (data?.researchResult?.softProducts) {
        [count, productFileFormData] = handleResearchResult(
          data?.researchResult?.softProducts,
          mutateProducts,
          summaryReportId,
          softProductType?.id,
          scientificPublicationGroup?.id,
          {
            productFileFormData,
            count,
          }
        );
      }

      if (data?.researchResult?.hardProducts) {
        [count, productFileFormData] = handleResearchResult(
          data?.researchResult?.hardProducts,
          mutateProducts,
          summaryReportId,
          hardProductType?.id,
          scientificPublicationGroup?.id,
          {
            productFileFormData,
            count,
          }
        );
      }

      if (data?.researchResult?.scientificPublications) {
        [count, productFileFormData] = handleResearchResult(
          data?.researchResult?.scientificPublications,
          mutateProducts,
          summaryReportId,
          scientificPublicationType?.id,
          scientificPublicationGroup?.id,
          {
            productFileFormData,
            count,
          }
        );
      }

      if (data?.researchResult?.intellectualProperty) {
        [count, productFileFormData] = handleResearchResult(
          data?.researchResult?.intellectualProperty,
          mutateProducts,
          summaryReportId,
          null,
          intellectualPropertyGroup?.id,
          {
            productFileFormData,
            count,
          }
        );
      }

      if (data?.researchResult?.transferTechnology) {
        let order = 1;
        // eslint-disable-next-line no-restricted-syntax, no-unsafe-optional-chaining
        for (const transferTechnology of data?.researchResult?.transferTechnology) {
          order += 1;
          if (transferTechnology?.isUpdateNewValue || !transferTechnology?.id) {
            if (count === ASYNC_CONSTANT.NUMBER_PRODUCT) {
              mutateProducts.push(productFileFormData);
              productFileFormData = new FormData();
              productFileFormData.append('summaryReportId', summaryReportId);
              count = 0;
            }
            const transferTechnologySender = {
              summaryReportProductGroupId: intellectualPropertyGroup?.id,
              researchKpiGroupId: transferTechnology?.researchKpiGroupId,
              researchKpiId: transferTechnology?.researchKpiId,
              name: transferTechnology?.name,
              transferredYear: transferTechnology?.transferredYear,
              partner: transferTechnology?.partner,
              contractedDate: transferTechnology?.contractedDate,
              revenue: transferTechnology?.revenue,
              scale: transferTechnology?.scale,
              hasFile: false,
              order,
            };
            if (transferTechnology?.file) {
              productFileFormData.append('transferredTechnologyFiles', transferTechnology?.file);
              transferTechnologySender.hasFile = true;
            }
            if (transferTechnology?.id) {
              transferTechnologySender.id = transferTechnology?.id;
            }
            productFileFormData.append(
              'summaryReportTransferredTechnologies',
              JSON.stringify(transferTechnologySender)
            );
            count += 1;
          }
        }
      }

      if (data?.researchResult?.trainingResult) {
        [count, productFileFormData] = handleResearchResult(
          data?.researchResult?.trainingResult,
          mutateProducts,
          summaryReportId,
          null,
          trainingResultGorup?.id,
          {
            productFileFormData,
            count,
          }
        );
      }

      if (summaryReport?.summaryReport) {
        if (data?.appendixFiles?.length > 0) {
          let summaryReportAppendixIds = [];
          // eslint-disable-next-line no-restricted-syntax, no-unsafe-optional-chaining
          for (const appendixFile of data?.appendixFiles) {
            if (count === ASYNC_CONSTANT.NUMBER_PRODUCT) {
              productFileFormData.append(
                'summaryReportAppendixIds',
                JSON.stringify(summaryReportAppendixIds)
              );
              mutateProducts.push(productFileFormData);
              productFileFormData = new FormData();
              productFileFormData.append('summaryReportId', summaryReportId);
              summaryReportAppendixIds = [];
              count = 0;
            }
            productFileFormData.append('appendixFiles', appendixFile?.file);
            summaryReportAppendixIds.push('');
            count += 1;
          }
          if (count > 0) {
            productFileFormData.append(
              'summaryReportAppendixIds',
              JSON.stringify(summaryReportAppendixIds)
            );
          }
        }
        if (data?.summaryReportFile instanceof File) {
          productFileFormData.append('summaryReportFile', data?.summaryReportFile);
          count += 1;
        }
      }

      if (count > 0) {
        mutateProducts.push(productFileFormData);
      }
      if (mutateExpenditures.length > 0) {
        await new Promise((resolve, reject) => {
          eachLimit(
            mutateExpenditures,
            ASYNC_CONSTANT.EACH_LIMIT,
            async (expenditurePeriodFileFormDataItem, callback) => {
              if (expenditurePeriodFileFormDataItem.type === 'DELETE') {
                await mutateAsyncDeleteAllocatedExpenditure({
                  summaryReportId,
                  id: expenditurePeriodFileFormDataItem.id,
                });
              } else if (expenditurePeriodFileFormDataItem.type === 'CREATE') {
                await mutateAsyncCreateAllocatedExpenditure({
                  summaryReportId,
                  body: expenditurePeriodFileFormDataItem.data,
                });
              } else if (expenditurePeriodFileFormDataItem.type === 'UPDATE') {
                await mutateAsyncUpdateAllocatedExpenditure({
                  summaryReportId,
                  id: expenditurePeriodFileFormDataItem.data.get('id'),
                  body: expenditurePeriodFileFormDataItem.data,
                });
              }
              callback(null);
            },
            (err) => {
              if (err) {
                reject(err);
              } else {
                resolve();
              }
            }
          );
        });
        if (expenditurePeriodsDelete?.length > 0) {
          setExpenditurePeriodsDelete([]);
        }
      }
      expenditureFileFormData.append('summaryReportId', summaryReportId);
      if (data?.researchResult) {
        await mutateAsyncUpdateSummary({
          id: summaryReportId,
          body: createOrUpdateSummaryDataSender,
        });
        if (mutateProducts.length > 0) {
          await new Promise((resolve, reject) => {
            eachLimit(
              mutateProducts,
              ASYNC_CONSTANT.EACH_LIMIT,
              async (productFileFormDataItem, callback) => {
                await mutateAsyncUpdateProductFile(productFileFormDataItem);
                callback(null);
              },
              (err) => {
                if (err) {
                  reject(err);
                } else {
                  resolve();
                }
              }
            );
          });
        }
        if (data?.expenditureFile instanceof File) {
          await mutateAsyncUpdateExpenditureFile(expenditureFileFormData);
        }
        if (productFilesDelete?.length > 0) {
          await mutateAsyncDeleteFileAppendix({
            summaryReportId,
            summaryReportProductIds: productFilesDelete,
          });
          setProductFilesDelete([]);
        }
        if (transferredTechnologyFilesDelete?.length > 0) {
          await mutateAsyncDeleteFileAppendix({
            summaryReportId,
            summaryReportTransferredTechnologyIds: transferredTechnologyFilesDelete,
          });
          setTransferredTechnologyFilesDelete([]);
        }
        if (appendixFilesDelete?.length > 0) {
          await mutateAsyncDeleteFileAppendix({
            summaryReportId,
            summaryReportAppendixIds: appendixFilesDelete,
          });
          setAppendixFilesDelete([]);
        }
        reset({}, { keepValues: true });
        setResetAppendixFiles(true);
        refetch();
        toast(TOAST.SUCCESS, t('submitDocument.toast.updateSuccess'));
        handleTabChange();
      }
    }
  };

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('projectProposal.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setIsSubmitModalOpen(false)}
        autoFocus
      />
      <Button
        label={t('projectProposal.ok')}
        className="w-7rem"
        severity="info"
        onClick={async () => {
          const res = await mutateAsyncSubmitSummaryReport({ summaryReportId });
          if (res?.status.toString().startsWith('2')) {
            setIsSubmitModalOpen(false);
            reset({}, { keepValues: true });
            refetch();
            if (smrType === SUMMARY_REPORT_TYPE.MIDTERM_DOCUMENT) {
              toast(TOAST.SUCCESS, t('submitDocument.toast.midterm'));
            } else if (smrType === SUMMARY_REPORT_TYPE.ACCEPTANCE_DOCUMENT) {
              toast(TOAST.SUCCESS, t('submitDocument.toast.acceptance'));
            } else if (smrType === SUMMARY_REPORT_TYPE.LIQUIDATION_DOCUMENT) {
              toast(TOAST.SUCCESS, t('submitDocument.toast.liquidation'));
            }
          } else {
            toast(TOAST.ERROR, t('submitDocument.toast.error'));
          }
        }}
      />
    </div>
  );

  const handleDownloadFile = async (filename, fileNameFormat = '', folder = '') => {
    const res = await mutateAsyncDownloadFile({
      summaryReportId,
      filename,
      folder,
    });
    if (res?.data) {
      const file = new Blob([res.data]);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(file);
      link.download = fileNameFormat || filename;

      link.click();
    }
  };

  const handleSubmitClick = () => {
    // Check constraint r08 file
    if (!summaryReport?.summaryReport?.summaryReportFileUrl) {
      toast(TOAST.WARN, t('errorMessage.summaryReportFileRequired'));
      return;
    }

    // Pass all constraints
    setIsSubmitModalOpen(true);
  };

  // # End region event

  useEffect(() => {
    const data = summaryReport?.summaryReport;
    if (data) {
      // only acceptance
      setSummaryReportAppendixeArray(summaryReport?.summaryReportAppendixes);

      setValue(
        'summaryReportAllocatedExpenditures',
        data?.summaryReportAllocatedExpenditures?.filter((item) => !item?.fromOtherFund) ?? []
      );
      setValue(
        'summaryReportAllocatedExpenditureFromOtherFund',
        data?.summaryReportAllocatedExpenditures?.find((item) => item?.fromOtherFund) ?? {}
      );

      // un-file
      setValue('summaryReportFinishedTasks', data?.summaryReportFinishedTasks ?? []);
      setValue('summaryReportUnfinishedTasks', data?.summaryReportUnfinishedTasks ?? []);
      setValue('summaryReportConferences', data?.summaryReportConferences ?? []);
      setValue('summaryReportParticipants', data?.summaryReportParticipants ?? []);

      for (let i = 0; i < data?.summaryReportParticipants.length; i += 1) {
        setValue(
          `summaryReportParticipants.${i}.joiningDate`,
          new Date(data?.summaryReportParticipants[i]?.joiningDate)
        );
      }
      for (let i = 0; i < data?.summaryReportConferences.length; i += 1) {
        setValue(
          `summaryReportConferences.${i}.organizedDate`,
          new Date(data?.summaryReportConferences[i]?.organizedDate)
        );
      }

      setValue(
        'researchResult.softProducts',
        summaryReport?.summaryReportProducts?.scientificPublications?.softProducts
      );
      setValue(
        'researchResult.hardProducts',
        summaryReport?.summaryReportProducts?.scientificPublications?.hardProducts
      );
      setValue(
        'researchResult.scientificPublications',
        summaryReport?.summaryReportProducts?.scientificPublications?.scientificPublications
      );
      setValue(
        'researchResult.intellectualProperty',
        summaryReport?.summaryReportProducts?.intellectualPropertys
      );
      setValue(
        'researchResult.trainingResult',
        summaryReport?.summaryReportProducts?.trainingResults
      );
      setValue('researchResult.transferTechnology', data?.summaryReportTransferredTechnologies);
      for (let i = 0; i < data?.summaryReportTransferredTechnologies.length; i += 1) {
        if (data?.summaryReportTransferredTechnologies[i]?.contractedDate) {
          setValue(
            `researchResult.transferTechnology.${i}.contractedDate`,
            new Date(data?.summaryReportTransferredTechnologies[i]?.contractedDate)
          );
        }
      }
      const summaryReportExpenditure =
        data?.summaryReportExpenditures?.filter((item) => item?.no === 0) ?? [];
      const subSummaryReportExpenditures =
        data?.summaryReportExpenditures?.filter((item) => item?.no !== 0) ?? [];
      setValue('summaryReportExpenditures', subSummaryReportExpenditures ?? []);
      setValue(
        'expenditureFromVNU',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Funding for the project is allocated by VNU',
          'expenditure'
        )
      );
      setValue(
        'expenditureAllocated',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Allocated expenditure',
          'expenditure'
        )
      );
      setValue(
        'expenditureUsed',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Used expenditure',
          'expenditure'
        )
      );
      setValue(
        'expenditurePropose',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Suggested expenditures',
          'expenditure'
        )
      );
      setValue(
        'noteForExpenditureFromVNU',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Funding for the project is allocated by VNU',
          'notes'
        )
      );
      setValue(
        'noteForExpenditureAllocated',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Allocated expenditure',
          'notes'
        )
      );
      setValue(
        'noteForExpenditureUsed',
        setExpenditureTableOfSummaryReport(summaryReportExpenditure, 'Used expenditure', 'notes')
      );
      setValue(
        'noteForExpenditurePropose',
        setExpenditureTableOfSummaryReport(
          summaryReportExpenditure,
          'Suggested expenditures',
          'notes'
        )
      );

      setValue('expenditureFileUrl', data?.expenditureFileUrl ?? '');

      setValue('suggestion', data?.suggestion ?? '');
      setValue('contentReview', data?.contentReview ?? '');
      setValue('productReview', data?.productReview ?? '');
      setValue('processReview', data?.processReview ?? '');
    }
  }, [summaryReport]);

  return (
    <>
      {isLoading && <Loading />}
      <div className="project-proposal-form m-0 bg-white p-5 p-fluid">
        <form
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="off"
          className="form-midterm-container"
        >
          <Fieldset className="border-none p-0 p-fluid">
            {/* Tab 1 */}
            <div className={tab !== 0 ? 'hidden' : ''}>
              <GeneralInfo
                onChangeAppliedYear={setAppliedYear}
                control={control}
                errors={errors}
                setValue={setValue}
                expenditureFromOtherFund={expenditureFromOtherFund}
                projectCode={projectCode}
                setExpenditurePeriodsDelete={setExpenditurePeriodsDelete}
                handleDownloadFile={handleDownloadFile}
                disabled={!!summaryReport?.summaryReport?.isSubmit}
              />
            </div>
            {/* Tab 2 */}
            <div className={tab !== 1 ? 'hidden' : ''}>
              <h4 className="mt-1 mb-0">B0. Sản phẩm đăng ký theo thuyết minh</h4>
              <RegisteredKPI
                softProducts={projectData?.projectProposal?.softProducts}
                hardProducts={projectData?.projectProposal?.hardProducts}
                kpis={projectData?.projectProposal?.projectProposalResearchKpis || []}
              />
              <div>
                <h4 className="my-1">{t('r05.b.b1.title')}</h4>
                <h6 className="my-2 font-bold">{t('r05.b.b1.no1.title')}</h6>
                <ContentCompletedTable
                  control={control}
                  errors={errors}
                  disabled={!!summaryReport?.summaryReport?.isSubmit}
                />
                <h6 className="my-2">{t('r05.b.b1.no2.title')}</h6>
                <ContentNotCompletedTable
                  control={control}
                  errors={errors}
                  disabled={!!summaryReport?.summaryReport?.isSubmit}
                />
              </div>
              <h4 className="my-1">{t('r05.b.b2.title')}</h4>
              <Product
                projectCode={projectCode}
                researchKpis={researchKpis}
                researchKpiGroups={researchKpiGroups}
                control={control}
                errors={errors}
                disabled={!!summaryReport?.summaryReport?.isSubmit}
                handleDownloadFile={handleDownloadFile}
                setProductFilesDelete={setProductFilesDelete}
                setTransferredTechnologyFilesDelete={setTransferredTechnologyFilesDelete}
                projectProposal={projectData?.projectProposal}
                yearProposed={appliedYearOfResearchKpis}
              />
              <h4>{t('r05.b.b3.title')}</h4>
              <WorkshopTable
                control={control}
                errors={errors}
                disabled={!!summaryReport?.summaryReport?.isSubmit}
              />
              <p className="mt-4">{t('r05.b.b3.no2.description')}</p>
              <ParticipantsTable
                control={control}
                errors={errors}
                disabled={!!summaryReport?.summaryReport?.isSubmit}
              />
            </div>
            {/* Tab 3 */}
            <div className={tab !== 2 ? 'hidden' : ''}>
              <h4 className="my-1">{t('r05.b.b4.title')}</h4>
              <ExpenditureTable
                control={control}
                errors={errors}
                disabled={!!summaryReport?.summaryReport?.isSubmit}
              />
              <h5 className="mb-0">
                {t('r05.b.b4.expenditureProof')}
                <span className="font-bold text-red-500"> *</span>
              </h5>
              <CustomFileInput
                name="expenditureFile"
                disabled={!!summaryReport?.summaryReport?.isSubmit}
                defaultNameFile={`${convertUnicodeToAscii(projectCode).replace(
                  /\//g,
                  '_'
                )}-MinhChungKinhPhi-${summaryReport?.summaryReport?.version || 1}.xlsx`}
                control={control}
                errors={errors}
                accept=".xlsx,.pdf"
                acceptOnly="pdfExcelOnly"
                maxFileSize={30000000}
              />
              {summaryReport?.summaryReport?.expenditureFileUrl && (
                <span
                  className="p-button p-button-text p-button-sm mt-1 p-0"
                  onClick={() =>
                    handleDownloadFile(
                      summaryReport?.summaryReport?.expenditureFileUrl,
                      formatFileName(summaryReport?.summaryReport?.expenditureFileUrl)
                    )
                  }
                >
                  {summaryReport?.summaryReport?.expenditureFileUrl.includes('.pdf') ? (
                    <i className="pi pi-file-pdf text-red-500 text-xl" />
                  ) : (
                    <i className="pi pi-file-excel text-green-500 text-xl" />
                  )}
                  <span className="ml-1 text-blue-500 underline font-italic text-base">
                    {formatFileName(summaryReport?.summaryReport?.expenditureFileUrl)}
                  </span>
                </span>
              )}
            </div>
            {/* Tab 4 */}
            <div className={tab !== 3 ? 'hidden' : ''}>
              <Review
                control={control}
                errors={errors}
                readOnly={!!summaryReport?.summaryReport?.isSubmit}
              />

              <div className="mt-4">
                <h5 className="m-0">
                  {t('r05.uploadSummaryReport')} <span className="text-red-500">*</span>{' '}
                  <a
                    className="text-blue-500 font-italic text-lg font-medium"
                    href="/files/R08-BAO-CAO-TONG-KET.docx"
                    download
                  >
                    {t('formLayout.action.download')} {t('r05.fileTemplate')}{' '}
                    <i className="pi pi-download text-blue-500" />
                  </a>
                </h5>
                <CustomFileInput
                  name="summaryReportFile"
                  defaultNameFile={`${convertUnicodeToAscii(projectCode).replace(
                    /\//g,
                    '_'
                  )}-BaoCaoTongKet.pdf`}
                  control={control}
                  errors={errors}
                  accept=".pdf"
                  acceptFileMessage="Chỉ chấp nhận file PDF"
                  acceptOnly="pdfOnly"
                  maxFileSize={30000000}
                />
              </div>
              {summaryReport?.summaryReport?.summaryReportFileUrl && (
                <span
                  className="p-button p-button-text p-button-sm mt-1 p-0"
                  onClick={() =>
                    handleDownloadFile(
                      summaryReport?.summaryReport?.summaryReportFileUrl,
                      formatFileName(summaryReport?.summaryReport?.summaryReportFileUrl)
                    )
                  }
                >
                  <i className="pi pi-file-pdf text-red-500 text-xl" />
                  <span className="ml-1 text-blue-500 underline font-italic text-base">
                    {formatFileName(summaryReport?.summaryReport?.summaryReportFileUrl)}
                  </span>
                </span>
              )}

              <ManagementAppendix
                projectProposalId={summaryReport?.summaryReport?.project?.projectProposalId}
                project={summaryReport?.summaryReport?.project}
                attachment={summaryReport?.attachments}
              />

              <UploadMultipleFile
                control={control}
                errors={errors}
                summaryReportAppendixeArray={summaryReportAppendixeArray}
                handleDownloadFile={handleDownloadFile}
                setAppendixFilesDelete={setAppendixFilesDelete}
                disabled={summaryReport?.summaryReport?.isSubmit}
                setSummaryReportAppendixeArray={setSummaryReportAppendixeArray}
                resetAppendixFiles={resetAppendixFiles}
                setResetAppendixFiles={setResetAppendixFiles}
                projectCode={summaryReport?.summaryReport?.projectCode}
                reset={reset}
              />
            </div>
          </Fieldset>
          {/* Tab 5 */}
          {tab !== 4 && (
            <div className="flex justify-content-end mt-2">
              <Button
                type="submit"
                className="btn-control font-semibold mr-3"
                severity="success"
                onClick={() => {
                  setIsWillNext(false);
                  checkValidation();
                }}
                disabled={
                  (!(isDirty && Object.keys(dirtyFields).length) ||
                    !isEditable ||
                    isSubmitSummaryReportLoading ||
                    isUpdateProductFileLoading ||
                    isUpdateExpenditureFileLoading ||
                    isUpdateSummaryLoading ||
                    isDeleteFileAppendix ||
                    isCreateAllocatedExpenditureLoading ||
                    isUpdateAllocatedExpenditureLoading ||
                    isDeleteAllocatedExpenditureLoading) &&
                  appendixFilesDelete.length === 0
                }
              >
                {t('formLayout.save')}
              </Button>
              <Button
                type={isEditable ? 'submit' : 'button'}
                className="p-button-next btn-control"
                disabled={
                  isSubmitSummaryReportLoading ||
                  isUpdateProductFileLoading ||
                  isUpdateExpenditureFileLoading ||
                  isUpdateSummaryLoading ||
                  isDeleteFileAppendix ||
                  isCreateAllocatedExpenditureLoading ||
                  isUpdateAllocatedExpenditureLoading ||
                  isDeleteAllocatedExpenditureLoading
                }
                onClick={() => {
                  if (
                    (!(isDirty && Object.keys(dirtyFields).length) || !isEditable) &&
                    appendixFilesDelete.length === 0
                  ) {
                    if (isEditable && !validateRegisteredProductCount(getValues())) {
                      return;
                    }

                    setTab((prev) => prev + 1);
                  } else {
                    setIsWillNext(true);
                    checkValidation();
                  }
                }}
              >
                {t('formLayout.next')}
              </Button>
            </div>
          )}
          {(isDownloadFileLoading ||
            isSubmitSummaryReportLoading ||
            isUpdateProductFileLoading ||
            isUpdateExpenditureFileLoading ||
            isUpdateSummaryLoading ||
            isDeleteFileAppendix) && <Loading />}
        </form>
        <div className={tab !== 4 ? 'hidden' : 'ml-4'}>
          <ReviewForm
            summaryReport={summaryReport}
            handleDownloadFile={handleDownloadFile}
            control={control}
            errors={errors}
          />
          <div className="flex justify-content-end mt-6">
            <Button
              type="button"
              className="btn-submit  font-semibold mr-3"
              severity="danger"
              onClick={() => navigate(-1)}
            >
              {t('submitDocument.back')}
            </Button>
            {!isSubmitDocument && (
              <Button
                type="button"
                className="btn-submit font-semibold mr-3"
                severity="success"
                onClick={handleSubmitClick}
                disabled={isSubmitDocument}
              >
                {t('submitDocument.submit')}
              </Button>
            )}
            {hasSummaryReportRevise && (
              <Button
                type="button"
                className="btn-submit font-semibold mr-3 w-12rem"
                severity="warning"
                onClick={() => setIsCompleteReviseModalOpen(true)}
                disabled={!hasSummaryReportRevise}
              >
                {t('submitDocument.revise')}
              </Button>
            )}
          </div>
        </div>
        <Dialog
          header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
          visible={isSubmitModalOpen}
          position="center"
          style={{ width: '400px' }}
          onHide={() => setIsSubmitModalOpen(false)}
          draggable={false}
          footer={footerConfirmationSubmit}
        >
          <Message
            className="mt-4 w-full"
            severity="warn"
            text={t('submitDocument.confirmationMessage')}
          />
        </Dialog>
        {id && (
          <CompleteReviseModal
            isCompleteReviseModalOpen={isCompleteReviseModalOpen}
            setIsCompleteReviseModalOpen={setIsCompleteReviseModalOpen}
            id={id}
            refetch={refetchSummaryReportRevises}
          />
        )}
      </div>
    </>
  );
}

SummaryReportEditForm.propTypes = {
  smrType: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  tab: PropTypes.number,
  setTab: PropTypes.func,
  isDirty: PropTypes.bool.isRequired,
  dirtyFields: PropTypes.shape({}).isRequired,
  checkValidation: PropTypes.func.isRequired,
};

SummaryReportEditForm.defaultProps = {
  smrType: SUMMARY_REPORT_TYPE.ACCEPTANCE_DOCUMENT,
  tab: 0,
  setTab: () => null,
};
